
import {Component, Prop, Vue, Watch} from "vue-property-decorator";
// HTTP hataları (403/409/422) global axios kesicisinde (plugins/axios.ts) gösterilir
// (409 için StatusCodeHelper::error409 — DEV-2684 U4).
import {
  MODUL_AGACI,
  ModulDugumu,
  ModulYetkiSatiri,
  UrunGrubu,
  YetkiKademe,
  kademeEnAz,
  modulEtiketi,
  modulIkonu,
  tumModulAnahtarlari,
} from "@/enum/YetkiModulleri";

// duzDugumler()'in döndürdüğü düz satır: düğüm + girinti seviyesi + ata modül zinciri (görünürlük).
interface DuzDugum {
  dugum: ModulDugumu;
  seviye: number;
  ustZinciri: string[];
}
import KademeSecici from "@/components/izinler/KademeSecici.vue";
import IslemSecici from "@/components/izinler/IslemSecici.vue";
import {duzenlemeEngeli} from "@/components/izinler/duzenlemeEngeli";
import {kural1Kilidi, kural1Uygula, ustHaritasiKur} from "@/components/izinler/kural1";

@Component({
  components: {KademeSecici, IslemSecici},
})
export default class KullaniciIzinleriMatris extends Vue {
  // Seçili rolün kimliği ve adı (rol listesinden gelir).
  @Prop({type: [Number, String], default: null}) roleId!: number | string | null;
  @Prop({type: String, default: ""}) roleName!: string;
  // B7: yönetici rolü tüm bölümlere erişir; matrisi salt-okunur olur (kaydetse de backend
  // yöneticiyi iki tarafta da atladığı için değişiklik etkisizdir — yanıltıcı düzenlemeyi önle).
  @Prop({type: Boolean, default: false}) yoneticiRolu!: boolean;

  ready = false;
  kaydediliyor = false;
  // U3: GET başarısızsa true; matris gösterilmez/kaydedilmez.
  yuklemeHatasi = false;
  // B2: her yükleme çağrısına artan bir numara verilir; yalnız en son çağrının sonucu yazılır.
  // Rol hızlı değiştirilince bayat bir yanıtın taze matrisi ezmesi (yarış) böyle önlenir.
  yuklemeNo = 0;
  // modul -> satır. Liste TAMAMEN SUNUCUDAN gelir (D7); istemci hiçbir modül eklemez.
  satirlar: { [modul: string]: ModulYetkiSatiri } = {};
  // DEV-2684: sunucunun bu rol için matris kilidi açıklaması (kendi rolü, yönetici rolü, sizi aşan rol);
  // GET yanıtındaki duzenlenebilir/duzenleme_engeli alanından. Kilit yoksa null.
  hedefEngeli: string | null = null;

  // Accordion durumu (yalnız GÖSTERİM). Ürün grupları varsayılan AÇIK, alt başlıklı
  // düğümler varsayılan KAPALI. Kayıt yok, veri etkilenmez.
  acikGruplar: { [urun: string]: boolean } = {};
  acikDugumler: { [modul: string]: boolean } = {};

  // Kural 3 — yeni/hiç yapılandırılmamış rol mü (yüklenen her satır `gizli`). Yalnız bu durumda
  // yönetici bir üst modülü ilk kez elle açınca altları Görüntüle ile ön doldurulur. Yüklemede hesaplanır.
  yeniRol = false;
  // Kural 3 — "ilk açılışı" artık geçmiş üst modüller: ön doldurması uygulanmış ya da Kural 1
  // tarafından otomatik yükseltilmiş olanlar. İşaretli üstte ön doldurma bir daha tetiklenmez.
  onDoldurulanUstler: { [modul: string]: boolean } = {};

  // Kural 2 — kayıttan önce "üst açık ama alt yok" uyarı diyaloğu (ENGELLEME YOK, K2).
  k2Goster = false;
  k2Ustler: string[] = [];

  // DEV-2684: matris yazımı (PUT roles/{role}/modul-yetkileri) Kullanıcı İzinleri Düzenle + değiştir
  // ister (/ben anahtarı rol-duzenle; yönetici her zaman). Yoksa Kaydet ve seçiciler kapalıdır.
  get duzenleYetkisi(): boolean {
    return this.$helper.isAuthorized("rol-duzenle");
  }

  // Seçiciler ve Kaydet'in kapalı olacağı birleşik salt-okunur durumu (yönetici rolü ya da sunucunun
  // bu rol için verdiği kilit). Lisans kısıtı matrisi kapatmaz: uçları API'de lisanstan muaf.
  get saltOkunur(): boolean {
    return this.yoneticiRolu || this.hedefEngeli !== null;
  }

  // Kaydet yanındaki açıklama: yetki yoksa o; varsa sunucunun rol kilidi (yönetici rolünün kendi notu var).
  get kilitAciklamasi(): string | null {
    if (!this.duzenleYetkisi) {
      return "İzinleri değiştirme yetkiniz yok.";
    }
    return this.yoneticiRolu ? null : this.hedefEngeli;
  }

  // D7 gösterim ağacı: kanonik MODUL_AGACI yalnız sunucunun GERÇEKTEN döndürdüğü modüllere
  // ÖZYİNELEMELİ süzülür (n-seviye alt başlıklar dahil). Sunucudan gelip ağaçta olmayan modül,
  // kendi ürün grubuna anahtar adıyla düzenlenebilir satır olarak eklenir; eşleşen grup yoksa
  // sonda "Diğer" grubuna girer. Çizilen her satırın bir sunucu kaydı vardır.
  get gosterimAgaci(): UrunGrubu[] {
    const sunucuModulleri = new Set(Object.keys(this.satirlar));

    const suz = (dugumler: ModulDugumu[]): ModulDugumu[] => {
      const sonuc: ModulDugumu[] = [];
      dugumler.forEach((dugum) => {
        if (!sunucuModulleri.has(dugum.modul)) {
          return;
        }
        const cocuklar = suz(dugum.cocuklar || []);
        sonuc.push({
          modul: dugum.modul,
          // Ad API'den (`etiket`); yoksa okunur yedek (modulEtiketi).
          label: modulEtiketi(dugum.modul, this.satirlar[dugum.modul].etiket),
          cocuklar: cocuklar.length ? cocuklar : undefined,
        });
      });
      return sonuc;
    };

    const gruplar: UrunGrubu[] = [];
    MODUL_AGACI.forEach((grup) => {
      const dugumler = suz(grup.dugumler);
      if (dugumler.length) {
        gruplar.push({urun: grup.urun, baslik: grup.baslik, dugumler});
      }
    });

    const agactakiler = new Set(tumModulAnahtarlari());
    Object.keys(this.satirlar).forEach((modul) => {
      if (agactakiler.has(modul)) {
        return;
      }
      const urun = this.satirlar[modul].urun || null;
      let grup = gruplar.find((g) => g.urun === urun);
      if (!grup) {
        grup = gruplar.find((g) => g.urun === "diger");
        if (!grup) {
          grup = {urun: "diger", baslik: "Diğer", dugumler: []};
          gruplar.push(grup);
        }
      }
      grup.dugumler.push({modul, label: this.satirlar[modul].etiket || modul});
    });

    return gruplar;
  }

  // Bir ürün grubunun düğümlerini ÖZYİNELEMELİ olarak düz satır listesine açar: her satır kendi
  // girinti seviyesini ve ata modül zincirini taşır (görünürlük ve girinti bundan hesaplanır).
  // Tüm satırlar listeye girer (gizli olanlar dahil) — v-show görünürlüğü ata zincirinden belirler,
  // DOM'da kalırlar.
  duzDugumler(dugumler: ModulDugumu[], seviye = 0, ustZinciri: string[] = []): DuzDugum[] {
    const liste: DuzDugum[] = [];
    dugumler.forEach((dugum) => {
      liste.push({dugum, seviye, ustZinciri});
      if (dugum.cocuklar && dugum.cocuklar.length) {
        liste.push(...this.duzDugumler(dugum.cocuklar, seviye + 1, [...ustZinciri, dugum.modul]));
      }
    });
    return liste;
  }

  // Satır görünür mü: ata zincirindeki TÜM düğümler açık (genişletilmiş) olmalı. Üst-level
  // satırlar (boş zincir) grup açıkken her zaman görünür.
  dugumGorunur(node: DuzDugum): boolean {
    return node.ustZinciri.every((modul) => this.dugumAcik(modul));
  }

  // DEV-2684 bağımlılık ailesi — SUNUCUNUN `ust` alanından kurulur (addan türetme yasak,
  // DEMİR KURAL #11). ust -> o üste bağlı, sunucudan GELEN alt modüllerin anahtarları
  // (sunucu/config sırasında). Ağaç yapısı değil bu harita kural mantığının tek kaynağıdır.
  get ustHaritasi(): { [ust: string]: string[] } {
    return ustHaritasiKur(this.satirlar);
  }

  // Kural 1 — bir üst modülün alt başlıklarından en az biri Görüntüle/Düzenle ise, o üst
  // Görüntüle'ye KİLİTLENİR (daha düşük seçilemez). Kilit kademesi (YetkiKademe) ya da null döner;
  // KademeSecici bunu alt başlık açıkken düşük pill'leri kapatmak için kullanır.
  kademeKilidi(modul: string): YetkiKademe | null {
    return kural1Kilidi(modul, this.satirlar, this.ustHaritasi);
  }

  // Modül anahtarının görünen adı (diyalog listesi için): API `etiket`'i, yoksa okunur yedek.
  modulEtiketi(modul: string): string {
    const satir = this.satirlar[modul];
    return modulEtiketi(modul, satir ? satir.etiket : null);
  }

  // Kural 2 — üst modülü Görüntüle/Düzenle olan ama (sunucudan gelen) alt başlıklarından
  // hiçbiri açık olmayan üstler. Kayıttan ÖNCE uyarı listesi; engelleme değil.
  get k2EksikUstler(): string[] {
    const eksik: string[] = [];
    Object.keys(this.ustHaritasi).forEach((ust) => {
      const us = this.satirlar[ust];
      if (!us || !kademeEnAz(us.kademe, YetkiKademe.GORUNTULE)) {
        return;
      }
      const cocuklar = this.ustHaritasi[ust];
      const altAcik = cocuklar.some((c) => {
        const cs = this.satirlar[c];
        return !!cs && kademeEnAz(cs.kademe, YetkiKademe.GORUNTULE);
      });
      if (!altAcik) {
        eksik.push(ust);
      }
    });
    return eksik;
  }

  // D7 kayma uyarısı — birinci yön: sunucudan gelip ağaçta ETİKETİ OLMAYAN modüller
  // (gösterim ağacına anahtar adıyla eklenir; ekranın güncellenmesi gerekebilir).
  get etiketsizModuller(): string[] {
    const agactakiler = new Set(tumModulAnahtarlari());
    return Object.keys(this.satirlar).filter((m) => !agactakiler.has(m));
  }

  // D7 kayma uyarısı — ikinci yön: ağaçta olup SUNUCUDAN GELMEYEN modüller (çizilemez).
  get sunucudaOlmayanModuller(): string[] {
    return tumModulAnahtarlari().filter((m) => !this.satirlar[m]);
  }

  // Uyarı bloğu iki yönden herhangi biri doluysa gösterilir.
  get kaymaVar(): boolean {
    return this.etiketsizModuller.length > 0 || this.sunucudaOlmayanModuller.length > 0;
  }

  // Modül anahtarına göre gösterim ikonu (kanonik anahtar; etikete göre değil).
  modulIkonu(modul: string): string {
    return modulIkonu(modul);
  }

  // Ürün grubu varsayılan AÇIK: sözlükte açıkça false değilse açık kabul edilir.
  grupAcik(urun: string): boolean {
    return this.acikGruplar[urun] !== false;
  }

  grupToggle(urun: string) {
    this.$set(this.acikGruplar, urun, !this.grupAcik(urun));
  }

  // Çocuklu düğüm (Takip Listesi) varsayılan KAPALI: yalnız açıkça true ise açık.
  dugumAcik(modul: string): boolean {
    return this.acikDugumler[modul] === true;
  }

  dugumToggle(modul: string) {
    this.$set(this.acikDugumler, modul, !this.dugumAcik(modul));
  }

  // Grup rozeti: gruptaki toplam modül sayısı (tüm seviyeler — ÖZYİNELEMELİ sayım).
  grupModulSayisi(grup: UrunGrubu): number {
    const say = (dugumler: ModulDugumu[]): number =>
      dugumler.reduce((toplam, d) => toplam + 1 + say(d.cocuklar || []), 0);
    return say(grup.dugumler);
  }

  // Seçicilere verilecek GÖSTERİM satırı. Yönetici rolü tüm yetkileri bypass eder
  // (backend Gate::before ile tam erişim); ekran her modülü DÜZENLE + tüm işlemler açık
  // (yeşil) gösterir. Bu YALNIZ görünüm: gerçek matris verisi (satirlar) değişmez, ekran
  // yönetici için zaten salt-okunurdur ve sunucuya yazma yapılmaz. Yönetici olmayan rolde
  // (düzenlenebilir VEYA kısıtlı dönem salt-okunur) gerçek satır REFERANSI döner — v-model
  // mutasyonu ve Kaydet gövdesi bozulmasın diye kopya çıkarılmaz.
  gorunumSatiri(modul: string): ModulYetkiSatiri {
    const satir = this.satirlar[modul];
    if (this.yoneticiRolu && satir) {
      return {
        ...satir,
        kademe: YetkiKademe.DUZENLE,
        ekle: true,
        degistir: true,
        sil: true,
      };
    }
    return satir;
  }

  mounted() {
    if (this.roleId) {
      this.yukle();
    }
  }

  @Watch("roleId")
  onRoleChange(yeni: number | string | null) {
    if (yeni) {
      this.yukle();
    } else {
      // B2: rol temizlendiğinde uçuşta olan yükleme çağrısı da geçersizleşsin.
      this.yuklemeNo++;
      this.ready = false;
    }
  }

  async yukle() {
    // B2: bu çağrının numarası; yanıt dönene kadar daha yeni bir çağrı geldiyse sonuç yazılmaz.
    const no = ++this.yuklemeNo;
    const roleId = this.roleId;
    this.ready = false;
    this.yuklemeHatasi = false;
    this.satirlar = {};
    this.hedefEngeli = null;

    try {
      // $http yanıt kesici gövdeyi döndürür; dispatch zarfı {data:{role_id,yetkiler}}.
      // yetkiler: 49 tablo-modülünün tamamı (gizli varsayılan + urun + ust) — D7.
      const govde: any = await this.$http.get(`/api/v1/roles/${roleId}/modul-yetkileri`);
      if (no !== this.yuklemeNo) {
        return;
      }
      const yetkiler = (govde && govde.data && govde.data.yetkiler) || [];

      // Liste TAMAMEN sunucudan: satırlar yalnız sunucunun döndürdüğü modüllerden kurulur,
      // istemci eksik modül eklemez (D7). Kayma iki yönde uyarı bloğunda gösterilir.
      const taze: { [modul: string]: ModulYetkiSatiri } = {};
      yetkiler.forEach((satir: any) => {
        taze[satir.modul] = {
          modul: satir.modul,
          kademe: satir.kademe as YetkiKademe,
          ekle: !!satir.ekle,
          degistir: !!satir.degistir,
          sil: !!satir.sil,
          urun: satir.urun ?? null,
          etiket: satir.etiket ?? null,
          // Kural 1/2/3 aile bağı: sunucunun `ust` alanı (addan türetme yasak, DEMİR KURAL #11).
          ust: satir.ust ?? null,
        };
      });

      this.satirlar = taze;
      this.hedefEngeli = duzenlemeEngeli(govde && govde.data);
      // Kural 3 — rolün gizli dışında hiç modülü yoksa "yeni/hiç yapılandırılmamış" sayılır.
      const anahtarlar = Object.keys(taze);
      this.yeniRol = anahtarlar.length > 0 && anahtarlar.every((m) => taze[m].kademe === YetkiKademe.GIZLI);
      this.onDoldurulanUstler = {};
    } catch (error) {
      // U3: hatadan gelen boş sonuç gerçek veri gibi kullanılamaz; matris gösterilmez.
      if (no !== this.yuklemeNo) {
        return;
      }
      this.yuklemeHatasi = true;
    } finally {
      // Bayat çağrının sonucu hiçbir alanı (ready dahil) yazmaz.
      if (no === this.yuklemeNo) {
        this.ready = true;
      }
    }
  }

  // Kademe değişince: (1) düzenle dışında bayrakları temizle, (2) Kural 3 ön doldurma,
  // (3) Kural 1 üst yükseltme. Backend düzenle dışı kademede bayrağı reddeder.
  kademeDegisti(modul: string) {
    const satir = this.satirlar[modul];
    if (!satir) {
      return;
    }
    if (satir.kademe !== YetkiKademe.DUZENLE) {
      satir.ekle = false;
      satir.degistir = false;
      satir.sil = false;
    }
    // Kural 3 — yeni rolde bu üst ilk kez açıldıysa altları Görüntüle ile ön doldur.
    this.kural3OnDoldur(modul);
    // Kural 1 — alt başlığı açık olan üstleri en az Görüntüle'ye yükselt (422 önleme).
    this.kural1Yukselt();
  }

  // Kural 3 — YALNIZ yeni/hiç yapılandırılmamış rolde: yönetici bir üst modülü İLK KEZ ELLE
  // açınca (en az Görüntüle), gizli alt başlıkları GÖRÜNTÜLE ile ön doldur. Düzenle ASLA otomatik
  // verilmez. Her üst yalnız bir kez ön doldurulur. Görünür-Kapalı açılış sayılmaz (modül
  // görünür ama girilemez); Kural 1'in otomatik yükseltmesi de sayılmaz (kural1Yukselt işaretler).
  kural3OnDoldur(modul: string) {
    if (!this.yeniRol || this.onDoldurulanUstler[modul]) {
      return;
    }
    const cocuklar = this.ustHaritasi[modul];
    if (!cocuklar || !cocuklar.length) {
      return;
    }
    const us = this.satirlar[modul];
    if (!us || !kademeEnAz(us.kademe, YetkiKademe.GORUNTULE)) {
      // Üst henüz açılmadı (Gizli ya da Görünür-Kapalı) — ön doldurma tetiklenmez.
      return;
    }
    cocuklar.forEach((c) => {
      const cs = this.satirlar[c];
      if (cs && cs.kademe === YetkiKademe.GIZLI) {
        cs.kademe = YetkiKademe.GORUNTULE;
      }
    });
    this.$set(this.onDoldurulanUstler, modul, true);
  }

  // Kural 1 — alt başlığı en az Görüntüle olan her üstü, altından düşükse Görüntüle'ye çıkar.
  // (Sunucu da bunu 422 ile zorlar; ekran kullanıcıyı 422'ye düşürmeden önden uygular.)
  kural1Yukselt() {
    // Otomatik yükseltme yöneticinin "ilk açılışı" değildir: üst işaretlenir ki sonradan elle
    // değiştirildiğinde Kural 3 seçilmemiş kardeş altları açmasın.
    kural1Uygula(this.satirlar, this.ustHaritasi, (ust) => this.$set(this.onDoldurulanUstler, ust, true));
  }

  async kaydet() {
    // B2: matris hazır değilken (ilk yükleme sürerken / yarış guard'ı erken döndükten sonra)
    // kaydetme, aksi hâlde boş/bayat satır kümesi PUT edilebilir.
    if (this.saltOkunur || !this.roleId || !this.ready || this.yuklemeHatasi || !this.duzenleYetkisi || this.kaydediliyor) {
      return;
    }

    // Kural 2 — üst açık ama alt yok: kayıttan önce uyarı (engelleme değil, K2). Diyalog
    // "Böyle kaydet" ya da "İlk alt başlığı ekle" ile kaydetDevam'a döner.
    if (this.k2EksikUstler.length) {
      this.k2Ustler = this.k2EksikUstler.slice();
      this.k2Goster = true;
      return;
    }

    await this.kaydetDevam();
  }

  // Kural 2 diyaloğu — "İlk alt başlığı Görüntüle ile ekle": her eksik üstün ilk (sunucu
  // sırasındaki) alt başlığını Görüntüle yapar, sonra kaydeder.
  async k2IlkAltEkle() {
    // Diyalog kapanırken ikinci tık da buraya gelir; kayıt sürerken yeniden çalışmaz.
    if (this.kaydediliyor) {
      return;
    }
    this.k2Ustler.forEach((ust) => {
      const cocuklar = this.ustHaritasi[ust];
      if (cocuklar && cocuklar.length) {
        const ilk = this.satirlar[cocuklar[0]];
        if (ilk) {
          ilk.kademe = YetkiKademe.GORUNTULE;
          this.kademeDegisti(cocuklar[0]);
        }
      }
    });
    this.k2Goster = false;
    await this.kaydetDevam();
  }

  // Kural 2 diyaloğu — "Böyle kaydet": uyarıyı geçerek olduğu gibi kaydeder.
  async k2BoyleKaydet() {
    if (this.kaydediliyor) {
      return;
    }
    this.k2Goster = false;
    await this.kaydetDevam();
  }

  async kaydetDevam() {
    // Tek gönderim kilidi: düğme kapalı olsa da hiçbir yol kayıt sürerken ikinci PUT göndermez.
    if (this.kaydediliyor) {
      return;
    }
    this.kaydediliyor = true;
    try {
      // Tam matris gönderilir; backend role_id+modul üzerinden UPSERT eder. Liste sunucudan
      // geldiği için satır kümesi de sunucunun döndürdüğüyle aynıdır (bilinmeyenler dahil korunur).
      const yetkiler = Object.keys(this.satirlar).map((modul) => {
        const s = this.satirlar[modul];
        const duzenleKademesi = s.kademe === YetkiKademe.DUZENLE;
        return {
          modul: s.modul,
          kademe: s.kademe,
          // Güvenlik: düzenle kademesinde değilse bayraklar false gider (422 önlenir).
          ekle: duzenleKademesi && s.ekle,
          degistir: duzenleKademesi && s.degistir,
          sil: duzenleKademesi && s.sil,
        };
      });

      await this.$http.put(`/api/v1/roles/${this.roleId}/modul-yetkileri`, {yetkiler});
      this.$toast.success("İzinler kaydedildi.");
      this.$emit("saved");
    } catch (error) {
      // 403/409/422 global kesici tarafından gösterilir (409 -> StatusCodeHelper::error409).
    } finally {
      this.kaydediliyor = false;
    }
  }
}
